import React from 'react'
import Hero from '../components/Hero';
import transition from '../Utilities/transition';

const Home = () => {
    return (
        <Hero />
    )
}

export default transition(Home);
